import React from "react"

import PropTypes from "prop-types"
import {Image, Icon as SemanticIcon} from "semantic-ui-react"

import {StatusPillVariants} from "../../constants/statusPillVariants"
import {getDataTestId} from "../../utils/stringUtil"
import IconCounter from "../IconCounter"
import StatusPill from "../StatusPill"

import "./tile.scss"

export const TILE_VARIANTS = {
    DEFAULT: "default",
    IMAGE_SMALL: "image-small",
    SMALL: "small",
    SMALL_BLUE: "small-blue",
    SMALL_PINK: "small-pink",
    URSSAF_EN_COURS: "urssaf-en-cours",
}

const Tile = ({
    icon = null,
    iconCounterProps = null,
    title,
    description = null,
    disabled = false,
    variant = TILE_VARIANTS.DEFAULT,
    onClick = null,
    imgSrc = null,
    imgAlt = null,
    ...props
}) => (
    <button
        aria-describedby={description ? `${getDataTestId(title, "tuile")}Description` : undefined}
        aria-disabled={disabled}
        aria-label={title}
        className={`tile variant-${variant}${disabled ? " disabled" : ""}`}
        data-testid={getDataTestId(title, "tuile")}
        disabled={disabled}
        onClick={!disabled ? onClick : undefined}
        tabIndex={disabled ? -1 : 0}
        type="button"
        {...props}
    >
        {[TILE_VARIANTS.URSSAF_EN_COURS, TILE_VARIANTS.IMAGE_SMALL].includes(variant) ? (
            <Image alt={imgAlt} src={imgSrc} />
        ) : iconCounterProps ? (
            <IconCounter aria-hidden="true" {...iconCounterProps} icon={icon} />
        ) : (
            <SemanticIcon aria-hidden="true" className={`${icon} tile-icon`} />
        )}
        <span className="tile-title">{title}</span>
        {variant === TILE_VARIANTS.DEFAULT && (
            <span
                aria-hidden={!description}
                className="tile-description"
                id={`${getDataTestId(title, "tuile")}Description`}
            >
                {description}
            </span>
        )}
        {variant === TILE_VARIANTS.URSSAF_EN_COURS && <StatusPill variant={StatusPillVariants.EN_COURS} />}
    </button>
)

Tile.propTypes = {
    description: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconCounterProps: PropTypes.object,
    imgAlt: PropTypes.string,
    imgSrc: PropTypes.any,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(Object.values(TILE_VARIANTS)),
}

export default Tile
